<div
  class="landing-bookings-tile-container lato"
  [style.width]="isMobile ? '18.75rem' : '23.875rem'"
>
  <table style="height: 100%; width: 100%; border-collapse: collapse;">
    <tr class="landing-bookings-tile-content">
      <td valign="top">
        <div
          class="status"
          [ngClass]="{
            'confirmed': this.booking.status === 1,
            'checkedIn': this.booking.status === 2,
            'pending': this.booking.status === 9,
            'declined': this.booking.status === 10
          }"
        > {{ this.booking.statusTypeTextUI }}</div>
        <div class="status-message" [innerHtml]="booking?.statusMessageUI"></div>
        <hr>
        <div class="booking-title lato bold">{{ booking.bookingTitleUI}}</div>
        <div class="booking-dogs lato bold">{{ booking.petNamesUI}}</div>
        <div class="booking-location">{{ booking.franchise.name }}</div>
      </td>
    </tr>
    <tr>
      <td>
        <div
          *ngIf="this.booking.status !== 10"
          class="row no-gutters mt-2"
        >
          <div
            class="col"
            style="padding-right: 0.125rem;"
          >
            <button
              class="btn btn-outline-danger btn-block"
              (mousedown)="viewBookingDetails()"
              (click)="viewBookingDetails()"
            >View</button>
          </div>
          <div
            class="col"
            style="padding-left: 0.125rem;"
          >
            <button
              class="btn btn-outline-danger btn-block"
              (click)="cancelBooking()"
              (mousedown)="cancelBooking()"
            >Change/Cancel</button>
          </div>
        </div>
        <div
          *ngIf="booking.status === 10"
          class="row no-gutters mt-2"
        >
          <div class="col">
            <button
              class="btn btn-block btn-outline-danger"
              (click)="viewBookingDetails()"
              (mousedown)="viewBookingDetails()"
            >View</button>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
